/* eslint-disable import/prefer-default-export */
export const isTestEnvironment = () => process.env.BABEL_ENV === 'test';
